import * as React from "react";

interface CustomTabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const CustomTabPanel: React.FC<CustomTabPanelProps> = ({ children, value, index, ...other }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      style={{ paddingTop: 20 }}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
};

export default CustomTabPanel;
